import { useContext, useEffect, useRef, useState } from "react";
import SetTemprature from "../../constants/SetTemprature";
import TempratureChanges from "../../constants/TempratureChanges";
import { Context } from "../../context/Context";
import "./NumbersModal.css";
import { UpdateScenarioCommand } from "../../api/api";

const ScenarioThermostatSetTempModal = ({ selectValue, setTemp, setDiff }) => {
  const { setThermostatSetTempModal, thermostatSetTempModalType } =
    useContext(Context);
  const [value, setValue] = useState(selectValue);
  const modalName = useRef(null);
  const closeButton = useRef(null);

  useEffect(() => {
    setThermostatSetTempModal(modalName);
  }, []);

  const renderOptionsOfSelect = () => {
    if (thermostatSetTempModalType == 1) {
      // Set Temprature
      return SetTemprature.map((temp) => {
        if (temp.value == selectValue) {
          return (
            <option value={temp.value ?? ""} selected="selected">
              {temp.name}
            </option>
          );
        }
        return <option value={temp.value ?? ""}>{temp.name}</option>;
      });
    } else if (thermostatSetTempModalType == 2) {
      // Temprature Changes
      return TempratureChanges.map((chng) => {
        if (chng.value == selectValue) {
          return (
            <option value={chng.value ?? ""} selected="selected">
              {chng.name}
            </option>
          );
        }
        return <option value={chng.value ?? ""}>{chng.name}</option>;
      });
    }
  };

  const handleSubmit = () => {
    if (thermostatSetTempModalType == 1) {
      setTemp(value);
    } else if (thermostatSetTempModalType == 2) {
      setDiff(value);
    }
    closeButton.current.click();
  };

  return (
    // Modal
    <div
      className="modal fade"
      id="scenarioTimerModal"
      tabIndex="-1"
      aria-labelledby="scenarioTimerModalLable"
      aria-hidden="true"
      ref={modalName}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="equipmentsNameLable">
              {thermostatSetTempModalType == 1
                ? "دمای تنظیم (C°)"
                : "تغییرات دما (C°)"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref={closeButton}
            ></button>
          </div>
          <div className="modal-body">
            <div className="mb-3">
              <select
                id="timerSelect"
                className="form-select w-100"
                data-style="btn-default"
                value={value}
                onChange={(e) => setValue(e.target.value)}
              >
                {renderOptionsOfSelect()}
              </select>
            </div>
            <div>
              {/* <button
                type="button"
                className="btn btn-success-app mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButton}
              >
                انصراف
              </button> */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-success-app me-3 mb-2"
              onClick={handleSubmit}
            >
              ثبت
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScenarioThermostatSetTempModal;
